import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-bici-confirmacion-datos',
  templateUrl: './bici-confirmacion-datos.component.html',
  styleUrls: ['./bici-confirmacion-datos.component.css']
})
export class BiciConfirmacionDatosComponent implements OnInit {

  @Input()
  lead:any=null;
  leadOriginal: any={
    email: "",
    telefono_prefijo: "",
    telefono_numero: "",
  };

  errors: any = [];

  constructor(
    private api: ApiService,
    public activeModal: NgbActiveModal,
    public spinner: NgxSpinnerService
  ) { 

  }

  ngOnInit() { 
    this.leadOriginal.email = this.lead.email; 
    this.leadOriginal.telefono_prefijo = this.lead.telefono_prefijo;
    this.leadOriginal.telefono_numero = this.lead.telefono_numero;
  }

  close(){
    this.activeModal.dismiss();
  }

  send(){
    this.lead.email = this.leadOriginal.email; 
    this.lead.telefono_prefijo = this.leadOriginal.telefono_prefijo;
    this.lead.telefono_numero = this.leadOriginal.telefono_numero;
    this.lead.terminos_aceptados = true;

    this.spinner.show();
    this.api.updateLead(this.lead).subscribe(ret => {
      this.lead.terminos_aceptados = false;
      if (ret.status == "ok") {
        this.errors = [];              
        this.spinner.hide();
        this.activeModal.close();     
      }

      if (ret.status == "error") {
        this.errors = ret.errors;
        this.spinner.hide();
      }

    });

  }

}
